import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { FiEdit } from 'react-icons/fi';
import { useIntl } from 'react-intl';

import { UserContext } from '~contexts/user';
import { DAYS } from '~src/constants';

import Button from '~components/button';

const HOUR = 3600;

const CustomerDetails = () => {
  const intl = useIntl();

  const { user } = useContext(UserContext);
  const { wish } = user;
  const { address, maximumRate, duration, interval, timeframes, languages } = wish;

  return (
    <>
      {/* ADDRESS */}
      {address && address.address ? (
        <div className="c-group c-group--large">
          <div className="c-group__label">
            {intl.formatMessage({ id: 'containers.account.client-offer.address.label', defaultMessage: 'Address' })}
          </div>
          <div className="c-group__value">
            <div className="c-account__value">{address.address}</div>
          </div>
        </div>
      ) : null}

      {/* MAXIMUM RATE */}
      {maximumRate && (
        <div className="c-group c-group--large">
          <div className="c-group__label">
            {intl.formatMessage({ id: 'containers.account.client-offer.maximum-rate.label', defaultMessage: 'Maximum rate' })}
          </div>
          <div className="c-group__value">
            <div className="c-account__value">
              {intl.formatMessage(
                { id: 'containers.account.client-offer.maximum-rate.value', defaultMessage: '{amount} per hour' },
                {
                  amount: intl.formatNumber(maximumRate?.amount / 100, {
                    style: 'currency',
                    currency: maximumRate?.currency,
                  }),
                }
              )}
            </div>
            <div className="c-account__desc">
              {intl.formatMessage({
                id: 'containers.account.client-offer.maximum-rate.description',
                defaultMessage: 'We take into account what you want to pay per hour and only introduce workers below this hourly rate',
              })}
            </div>
          </div>
        </div>
      )}

      {/* Service */}
      {duration && interval ? (
        <div className="c-group c-group--large">
          <div className="c-group__label">
            {intl.formatMessage({ id: 'containers.account.client-offer.service.label', defaultMessage: 'Service' })}
          </div>
          <div className="c-group__value">
            {`${intl.formatMessage({ id: `interval.every-${interval}-weeks` })}, ${intl.formatMessage(
              {
                id: 'containers.account.client-offer.service.duration',
                defaultMessage: '{duration, plural, =1 {# hour} other { # hours}}',
              },
              { duration: duration / HOUR }
            )}`}
          </div>
        </div>
      ) : null}

      {/* AVAILABILITY */}
      <div className="c-group c-group--large">
        <div className="c-group__label">
          {intl.formatMessage({ id: 'containers.account.client-offer.availability.label', defaultMessage: 'Availability' })}
        </div>
        <div className="c-group__value">
          <div className="c-account__value">
            {timeframes &&
              DAYS.map((day) =>
                timeframes.indexOf(day) >= 0
                  ? intl.formatMessage({ id: `days.long.${day}` })
                  : false
              ).filter(Boolean).join(', ')}
          </div>
        </div>
      </div>

      {/* LANGUAGES */}
      <div className="c-group c-group--large">
        <div className="c-group__label">
          {intl.formatMessage({ id: 'containers.account.client-offer.languages.label', defaultMessage: 'Languages' })}
        </div>
        <div className="c-group__value">
          <div className="c-account__value">
            {languages && languages.map((d) => intl.formatMessage({ id: `languages.${d}` })).join(', ')}
          </div>
        </div>
      </div>
    </>
  );
};

const CustomerNoWish = () => {
  const intl = useIntl();

  return (
    <div>
      <p>{intl.formatMessage({ id: 'containers.account.client-offer.no-wish.content', defaultMessage: 'You have no wishes yet!' })}</p>
      <Link to="/edit-wish">
        <Button className="c-btn--secondary">
          {intl.formatMessage({ id: 'containers.account.client-offer.no-wish.button', defaultMessage: 'Create wish' })}
        </Button>
      </Link>
    </div>
  );
};

const CustomerOffer = () => {
  const intl = useIntl();

  const { user } = useContext(UserContext);

  return (
    <div className="c-box" data-cy="qa-preferences">
      <div className="c-box__content">
        <div className="c-editable">
          <div className="c-editable__content">
            <h3 className="l-headline--tertiary c-box__headline">
              {intl.formatMessage({ id: 'containers.account.client-offer.headline', defaultMessage: 'My wishes' })}
            </h3>
          </div>
          <Link to="/edit-wish" className="c-editable__button" data-cy="c-client-offer-editable__button">
            <FiEdit />
          </Link>
        </div>
        {!user?.wish?.address || !user?.wish?.address?.place_id ? <CustomerNoWish /> : <CustomerDetails />}
      </div>
    </div>
  );
};

export default CustomerOffer;
